var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { addCommasWithoutDecimal } from "@domains/utils/numberMethods";
import summarize from "@domains/utils/summarize";
import GenericStars from "@frameworks/salesjourney/components/Generic/Star";
import di from "../../di/serviceLocator";
import React, { forwardRef } from "react";
import Spinner from "react-bootstrap/Spinner";
import config from "@frameworks/salesjourney/config/domain";
import { useNavigate } from "react-router-dom";
import ClientTier from "@frameworks/salesjourney/components/Generic/ClientTier";
var ProfileTableBody = forwardRef(function (props, ref) {
    var navigate = useNavigate();
    var _a = __read(React.useState(false), 2), openAcc = _a[0], setOpenAcc = _a[1];
    var _b = __read(React.useState(false), 2), loader = _b[0], setLoader = _b[1];
    var _c = __read(React.useState([]), 2), clientList = _c[0], setClientList = _c[1];
    var getClientList = function (clientTier) {
        props.setClientRatingSummaryEntity(function (summaryEntity) {
            setLoader(true);
            var req = {
                tier: clientTier,
                page: 1,
                pageSize: 10000,
            };
            di.profile
                .getClientRatingSummaryDetailsEntity(req)
                .then(function (resp) {
                setClientList(resp);
                summaryEntity[props.selectedClientTierId].clientList = resp;
                setLoader(false);
            })
                .catch(function (error) {
                setClientList([]);
                summaryEntity[props.selectedClientTierId].clientList = [];
                setLoader(false);
            });
            return summaryEntity;
        });
    };
    var getClientSearchDataList = function (searchText, isClient) {
        var url = "";
        url =
            config.applicationFolder +
                "clientdetails/overview?link=".concat(isClient ? "overview" : "profile", "&uccCode=").concat(window.btoa(searchText));
        return url;
    };
    // const getClientSearchDataList = (searchText: string) => {
    //   if (!!searchText) {
    //     clientDi.clients
    //       .getClientSearchList({ searchText: searchText })
    //       .then((resp) => {
    //         if (resp && resp?.length > 0) {
    //           if (resp[0]?.isPartner) {
    //             let searchActionPayload: IPartnerAccountRequestPayload = {
    //               AcCode: resp[0].accountCode,
    //               page: 1,
    //               pageSize: 100,
    //             };
    //             clientDi.clients.clearSelectedClientData();
    //             clientDi.partnerOverview.getPartnerSearchAction(
    //               searchActionPayload,
    //               resp[0]
    //             );
    //           } else {
    //             clientDi.partnerOverview.clearALLStoreData();
    //             clientDi.clients.setSelectedClientOnSearchClick(resp[0]);
    //           }
    //           navigate(
    //             `/clientdetails/overview?link=${
    //               resp[0].isPartner ? "profile" : "overview"
    //             }`
    //           );
    //         }
    //       });
    //   }
    // };
    var profiletableMainlist = [
        {
            title: (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "hand_cursor" },
                    React.createElement("i", { className: openAcc ? "edel-icon-arrow-down" : "edel-icon-arrow-down" })))),
        },
        {
            title: (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "client-tier" },
                    React.createElement(ClientTier, { clientTier: props === null || props === void 0 ? void 0 : props.clientTier, showOnlyIcon: true })),
                props.clientTier)),
        },
        {
            title: (React.createElement("span", { className: "RobotoM_16_500" }, props.summarizeToggle ? (summarize(props.toatalAUA)) : (React.createElement(React.Fragment, null,
                addCommasWithoutDecimal(props.toatalAUA),
                " ",
                React.createElement("span", { className: "DMSanN_16_400 txt_secondary-gray" }, "INR"))))),
        },
        {
            title: props.totalCustomerCount,
            className: "text-end roboto-num",
        },
        {
            title: props.finalHighEngaged,
            className: isNaN(Number(props.finalHighEngaged)) ? "" : "roboto-num",
        },
        {
            title: props.totalAvgProductDepth,
            className: "text-end roboto-num",
        },
        {
            title: (React.createElement(React.Fragment, null,
                React.createElement(GenericStars, { ratingnumber: props.totalAvgRating, isstarspresent: true }))),
        },
    ];
    var profiletableSublist = clientList === null || clientList === void 0 ? void 0 : clientList.map(function (x) {
        // let clientName = x.clientName.split("(");
        return [
            { title: "" },
            {
                // title: `${clientName[0]}  (${clientName[1]}`,
                title: (React.createElement(React.Fragment, null,
                    React.createElement("a", { href: getClientSearchDataList(x === null || x === void 0 ? void 0 : x.acCode, true), className: "txt_black text-decoration-underline hand_cursor", onClick: function (e) {
                            e.stopPropagation();
                            //getClientSearchDataList(x?.acCode,true);
                        } }, x.clientName))),
            },
            {
                title: (React.createElement(React.Fragment, null, props.summarizeToggle ? (React.createElement("span", { className: "RobotoM_16_500" }, summarize(x.aua))) : (React.createElement(React.Fragment, null,
                    React.createElement("span", { className: "RobotoM_16_500" }, addCommasWithoutDecimal(x.aua)),
                    " ",
                    React.createElement("span", { className: "DMSanN_16_400 txt_secondary-gray" }, "INR"))))),
            },
            {
                title: "",
                className: "text-end roboto-num",
            },
            {
                title: x.highEngaged,
            },
            {
                title: x.productDepth,
                className: "text-end roboto-num",
            },
            {
                title: (React.createElement(React.Fragment, null,
                    React.createElement("span", { className: "DMSan_16_700" },
                        React.createElement(GenericStars, { ratingnumber: x.rating, isstarspresent: true })))),
            },
        ];
    });
    var setShowPanel = function (accOpen, clientTier) {
        setOpenAcc(!accOpen);
        if (!accOpen) {
            getClientList(clientTier);
        }
        else {
            setLoader(false);
            setClientList([]);
        }
    };
    // useImperativeHandle(ref, () => ({
    //   applySorting: (sortState: {
    //     sortType: boolean;
    //     sortKey: string;
    //     sortDataType: string;
    //   }) => {
    React.useEffect(function () {
        if (props.clientList && props.clientList.length > 0) {
            setClientList(props.clientList);
        }
    }, [props.clientList]);
    return (React.createElement("tbody", { className: "commonscroll-new profile-main ".concat(openAcc ? "openAccmain openAcc" : "") },
        React.createElement("tr", { onClick: function () {
                setShowPanel(openAcc, props.clientTier);
            }, className: " ".concat(openAcc ? "head-profile head-profile-colour" : "head-profile", " ") }, profiletableMainlist.map(function (items, i) {
            return (React.createElement("td", { key: i, className: items.className ? items.className : "" }, items.title));
        })),
        openAcc && loader ? (React.createElement("tr", { className: "spinner-box d-flex justify-content-center" },
            React.createElement("td", { colSpan: 6 },
                React.createElement(Spinner, { animation: "border", variant: "primary" })))) : (profiletableSublist === null || profiletableSublist === void 0 ? void 0 : profiletableSublist.map(function (items) {
            return (React.createElement("tr", { className: "open-acc-data profile " }, items.map(function (x) {
                return (React.createElement("td", { className: x.className ? x.className : "" }, x.title));
            })));
        }))));
});
export default ProfileTableBody;
